import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataHandler } from 'C4';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId()
      .then(appId => this.setState({ image: `https://cdn.travpromobile.com/apptool/app/${appId}/salesCompanion/bg.jpg` }));
  }

  render() {
    const { image } = this.state;
    const { blur, darken } = this.props;

    return (
      <div>
        {image &&
          <div
            style={{ backgroundImage: `url("${image}")` }}
            className={`backgroundImage ${blur && 'blur'} ${darken && 'darken'}`}
          />}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
